<div class="visitor-upfront-registration-filter no-field-space" [formGroup]="filterFormGroup">
  <sc-flex [centered]="true">
    <sc-string-field grow formControlName="filterText" labelDictionaryKey="shared.tmc-table.filter"></sc-string-field>
    @for (item of scopeFilters; track item) {
      <sc-content-spacer></sc-content-spacer>
      <span class="item {{item.icon}}" [matTooltip]="'Filter' | translate: [item.title, translationService.language, translationService.revision]"
      [ngClass]="{'selected': item.selected}" (click)="applyQuickFilter(item)"></span>
    }
    <sc-content-spacer></sc-content-spacer>
  </sc-flex>
</div>
